<script lang="ts">
  import { getContext, type Snippet } from "svelte";
  import { melt, createDropdownMenu } from "@melt-ui/svelte";
  import { ChevronRight } from "../../icons/index.js";

  interface Props {
    children?: Snippet;
  }

  let { children }: Props = $props();

  type MenuContext = ReturnType<typeof createDropdownMenu> & {
    submenu: ReturnType<ReturnType<typeof createDropdownMenu>["builders"]["createSubmenu"]>;
  };

  const {
    submenu: {
      elements: { subTrigger },
      states: { subOpen },
    },
  } = getContext<MenuContext>("menu");
</script>

<div
  class="group flex items-center justify-between rounded-lg px-2 py-1.5 select-none data-[highlighted]:bg-mono-000 data-[highlighted]:text-mono-900 data-[highlighted]:outline-hidden"
  {...$subTrigger} use:$subTrigger.action
  data-state={$subOpen ? "open" : "closed"}
>
  {@render children?.()}
  <span class="text-mono-500 group-data-[highlighted]:text-mono-900">
    <ChevronRight size={16} />
  </span>
</div>
